// extracted by mini-css-extract-plugin
export default {"tonalGraph":"styles_tonalGraph__gfztg","tonalPopupContent":"styles_tonalPopupContent__bqWqs"};